import { PropTypes } from 'prop-types';
import { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { selectCoreSiteId } from '../../settings/reducer';
import { selectMultiSiteSelection } from '../../site-selection/reducer';
import DetergentTrackerDataGetter from '../components/DetergentTrackerDataGetter';
import { useIntl } from 'react-intl';
import {
  getDetergents,
  getDetergentReadings,
  setReadingsFromDate,
  setReadingsUntilDate,
} from '../actions';
import {
  selectDetergentReadings,
  selectDetergentPods,
  selectReadingsFromDate,
  selectReadingsUntilDate,
  selectDetergentData,
} from '../reducer';
import DetergentTableContainer from './DetergentTableContainer';
import DetergentTabsContainer from './DetergentTabsContainer';

export const tempDetergents = ({
  fetchDetergents,
  detergents,
  detergentReadings,
  detergentPods,
  ...props
}) => {
  const siteId = useSelector(selectCoreSiteId),
    multiSites = useSelector(selectMultiSiteSelection);
  const [tabType, setTabType] = useState(null);
  const intl = useIntl();
  const [chartView, setChartView] = useState(true);
  const [dayRange, setDayRange] = useState(7);
  const dayRanges = [7, 30, 60, 90];
  useEffect(() => {
    fetchDetergents();
  }, [siteId, multiSites]);

  // update tab state when detergent pods becomes available
  useEffect(() => {
    if (detergentPods.length > 0 && !tabType) {
      setTabType(detergentPods[0]?.title || 'Detergent POD');
    }
  }, [detergentPods]);

  return (
    <div className="container-fluid">
      <div>
        {tabType && (
          <DetergentTabsContainer
            detergents={detergents}
            setTabType={setTabType}
            tabType={tabType}
            detergentReadings={detergentReadings}
            readingsDates={props.readingsDates}
            setFromDate={props.setFromDate}
            setUntilDate={props.setUntilDate}
          />
        )}
      </div>
      <div className="detergent-page-content">
        <div className="chart-title-section">
          <div className="chart-title">{intl.formatMessage({ id: 'detergentLevels' })}</div>
          <button className="button small" onClick={() => setChartView(!chartView)}>
            {chartView
              ? intl.formatMessage({ id: 'tableView' })
              : intl.formatMessage({ id: 'chartView' })}
          </button>
        </div>

        <div>
          {chartView ? (
            <>
              <div className="detergent-day-range-selector">
                {dayRanges.map((dayCount) => (
                  <button
                    key={dayCount}
                    className={`button small primary${dayRange !== dayCount ? ' inverted' : ''}`}
                    onClick={() => setDayRange(dayCount)}
                  >
                    {dayCount} {intl.formatMessage({ id: 'days' })}
                  </button>
                ))}
              </div>
              <DetergentTrackerDataGetter
                tabType={tabType}
                detergents={detergents}
                dayRange={dayRange}
              />
            </>
          ) : (
            <div className="detergent-table-edge">
              <DetergentTableContainer tabType={tabType} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

tempDetergents.propTypes = {
  detergents: PropTypes.arrayOf(PropTypes.object).isRequired,
  detergentReadings: PropTypes.shape({}),
  fetchDetergents: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  detergentPods: selectDetergentPods(state),
  detergents: selectDetergentData(state),
  detergentReadings: selectDetergentReadings(state),
  readingsDates: {
    fromDate: selectReadingsFromDate(state),
    untilDate: selectReadingsUntilDate(state),
  },
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchDetergents: getDetergents,
      getReadings: getDetergentReadings,
      setFromDate: setReadingsFromDate,
      setUntilDate: setReadingsUntilDate,
    },
    dispatch
  );

const enhance = compose(connect(mapStateToProps, mapDispatchToProps));

export default enhance(tempDetergents);
